import { render, staticRenderFns } from "./TicketsExchange.vue?vue&type=template&id=11d2dfb1&lang=pug"
import script from "./TicketsExchange.vue?vue&type=script&lang=js"
export * from "./TicketsExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports